<template>
  <div class="travelAgencyPendingList-page">
    <!-- 筛选 -->
    <div class="filter-box" @click="showTypePicker = true">
      <p v-if="typeOptionList[0].selectedValue == null" class="title">待办类型</p>
      <p v-else class="title option">{{ buildSelectedOptionName(typeOptionList) }}</p>
        <img src="../../assets/travelAgency/ic_jiantou_down1.png"
            alt
            class="down-icon"
        />
    </div>
    <!-- 列表 -->
    <van-list
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="loadMore"
    >
      <div v-for="(item, index) in listData" :key="index">
        <div class="pending-cell-box">
          <div class="header-box">
            <div class="tag">旅行社</div>
            <p v-if="item.type === 1" class="title">旅行社信息审核</p>
            <p v-else-if="item.type === 7" class="title">单项委托业务审批</p>
            <p v-else class="title">{{ item.todoDesc }}</p>
          </div>
          <div class="detail-box">
            <p class="detail-text">旅行社名称：{{ item.name }}</p>
            <p class="detail-text">上报时间：{{ item.createTime }}</p>
          </div>
          <div class="separator"></div>
          <div class="green-btn" @click="toHandleDetail(item)">立即处理</div>
        </div>
      </div>
    </van-list>
    <!-- 筛选弹窗 -->
    <van-popup v-model="showTypePicker"
               round
               position="bottom">
      <optionPicker :optionList="typeOptionList" @onConfirm="onTypePickerConfirm" @onClose="showTypePicker = false"></optionPicker>
    </van-popup>
  </div>
</template>

<script>
    import api from '../../service/modules/travel';
    import optionPicker from './components/option-picker.vue';

    export default {
        components: { optionPicker },
        data () {
            return {
                showTypePicker: false,
                typeOptionList: [
                    {
                        name: '待办类型',
                        selectedValue: null,
                        selectedName: '',
                        values: [
                            {
                                name: '全部',
                                value: null
                            },
                            {
                                name: '旅行社信息审核',
                                value: 1
                            },
                            {
                                name: '单项委托业务审批',
                                value: 7
                            }
                        ]
                    }
                ],
                loading: false,
                finished: false,
                pagination: { total: 0, current_page: 0, page_size: 0 },
                listData: []
            }
        },
        methods: {
            onTypePickerConfirm () {
              this.showTypePicker = false
              this.resetParams()
              this.fetchPendingList()
            },
            buildSelectedOptionName (optionList) {
              let optionData = optionList[0]
              for (let index = 0; index < optionData.values.length; index++) {
                const element = optionData.values[index];
                if (optionData.selectedValue == element.value) {
                  if (optionList.length == 1) {
                    // 只有一组选项
                    return element.name
                  } else {
                    // 多组选项
                    return element.name + '...'
                  }
                }
              }
            },
            fetchPendingList () {
              api.getPendingList({
                p: parseInt(this.pagination.current_page) + 1,
                pageSize: 20,
                type: this.typeOptionList[0].selectedValue
              }).then(res=>{
                if (res.ret === 0) {
                  this.listData = [...this.listData, ...res.data.list];
                  this.pagination = res.data.pagination;
                  this.loading = false;
                  if (this.pagination.current_page >= Math.ceil(this.pagination.total / this.pagination.page_size)) {
                      this.finished = true;
                  }
                }
              })
            },

            // 加载更多
            loadMore () {
              this.fetchPendingList()
            },

            resetParams () {
              this.pagination = { total: 0, current_page: 0, page_size: 0 }
              this.listData = []
              this.loading = true
              this.finished = false
            },

            // 去处理
            toHandleDetail (item) {
              this.$router.push({ path: '/travelAgency/info', query: { id: item.travelId, type: item.type, relevanceId: item.relevanceId } })
            }
        }
    }
</script>

<style scoped lang="less">
@vv: 3.75vw;
.travelAgencyPendingList-page {
  width: 100%;
  min-height: 100%;
  background: #f0f2f5;
  .filter-box {
    height: 44/@vv;
    display: flex;
    align-items: center;
    padding-left: 12/@vv;
    background-color: #fff;
    .title {
      font-size: 14/@vv;
      color: #54565c;
      font-weight: 400;
    }
    .option {
      font-weight: 500;
      color: #36b374;
    }
    .down-icon {
      margin-left: 3.5/@vv;
      width: 6/@vv;
      height: 4/@vv;
    }
  }
  .pending-cell-box {
    background-color: #fff;
    border-radius: 4px;
    padding: 12/@vv;
    margin: 12/@vv;
    display: flex;
    flex-direction: column;
    .header-box {
      display: flex;
      align-items: center;
      .tag {
        font-size: 12/@vv;
        color: #fff;
        background-color: #67abf2;
        padding: 2/@vv 4/@vv;
        border-radius: 2px;
        margin-right: 4/@vv;
      }
      .title {
        font-size: 16/@vv;
        font-weight: 500;
        color: #1e2226;
      }
    }
    .detail-box {
      display: flex;
      flex-direction: column;
      margin-top: 10/@vv;
      .detail-text {
        font-size: 14/@vv;
        color: #71747a;
        margin-bottom: 4/@vv;
      }
    }
    .separator {
      width: 100%;
      height: 1px;
      background-color: #f1f2f5;
      margin-top: 6/@vv;
      margin-bottom: 6/@vv;
    }
    .green-btn {
      margin-top: 4/@vv;
      width: 72/@vv;
      height: 28/@vv;
      background-color: #36b374;
      align-self: flex-end;
      color: #fff;
      font-size: 14/@vv;
      font-weight: 500;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 4px;
    }
  }
}

</style>
